"use client";
import { useAtom, useAtomValue } from "jotai";
import {
  nodeContextMenuAtom,
  newAssetIdentifierAtom,
  togglesAtomResettable,
  cursorAtom,
  isViewOnlyModeAtom,
} from "@zapier/canvas-state";

import { Canvas } from "../components/Canvas";
import { MultiSelectPanel } from "../components/MultiSelectPanel";
import { useDeleteCallbacks } from "../components/Canvas/useDeleteCallbacks";
import { ContextMenu } from "../components/ContextMenu";
import { AddAssetToProjectAlert } from "../components/AddAssetToProjectAlert";
import { CanvasBackground } from "../components/CanvasBackground";

import styles from "./IframeEmbeddedCanvas.module.css";

export function CanvasById() {
  const [nodeContextMenu, setNodeContextMenu] = useAtom(nodeContextMenuAtom);
  const { onNodeDeleteFromContextMenu } = useDeleteCallbacks();
  const newAssetIdentifier = useAtomValue(newAssetIdentifierAtom);
  const toggles = useAtomValue(togglesAtomResettable);
  const cursorMode = useAtomValue(cursorAtom);
  const isViewOnlyMode = useAtomValue(isViewOnlyModeAtom);

  return (
    <div className={styles.wrapper}>
      {cursorMode !== "add-group" && !isViewOnlyMode && <MultiSelectPanel />}
      <Canvas>
        <CanvasBackground />
        {toggles.manageProjectsMvp && newAssetIdentifier && (
          <AddAssetToProjectAlert />
        )}
        {nodeContextMenu && (
          <ContextMenu
            {...nodeContextMenu}
            onClose={() => setNodeContextMenu(null)}
            onNodeDelete={onNodeDeleteFromContextMenu}
          />
        )}
      </Canvas>
    </div>
  );
}
